'use client';

import { useEffect, useState } from 'react';

import { useYandexPayLoaded } from '@app/layouts/YandexPayProvider/YandexPayProvider';
import { APP_VERSION, YANDEX_MERCHANT_ID } from '@shared/constants/global';
import { YandexPayType } from '@shared/types/enums/pay.enum';

type SessionType = {
  mountWidget: (ref: unknown, data: unknown) => void;
};

type UseYandexPaySessionProps = {
  price: number;
  type: YandexPayType;
};

export const useYandexPaySession = ({ price, type }: UseYandexPaySessionProps) => {
  const [paymentSession, setPaymentSession] = useState<SessionType>();

  const loaded = useYandexPayLoaded();

  useEffect(() => {
    if (!loaded) return;

    const YaPay = window.YaPay;

    const paymentData = {
      // Для отладки нужно явно указать `SANDBOX` окружение,
      // для продакшена параметр можно убрать или указать `PRODUCTION`
      env: APP_VERSION === 'prod' ? 'PRODUCTION' : YaPay?.PaymentEnv.Sandbox,

      // Версия 4 указывает на тип оплаты сервисом Яндекс Пэй
      // Пользователь производит оплату на форме Яндекс Пэй,
      // и мерчанту возвращается только результат проведения оплаты
      version: 4,

      // Код валюты в которой будете принимать платежи

      currencyCode: YaPay?.CurrencyCode.Rub,
      merchantId: YANDEX_MERCHANT_ID,
      totalAmount: price,
      availablePaymentMethods: [type]
    };

    const onPayButtonClick = async () => {};
    const onFormOpenError = () => {};

    YaPay?.createSession(paymentData, {
      onPayButtonClick: onPayButtonClick,
      onFormOpenError: onFormOpenError
    })
      .then((session) => {
        setPaymentSession(session);
      })
      .catch((err) => {
        console.error('Error creating Yandex Pay session', err);
      });
  }, [loaded, price, type]);

  return { paymentSession, loaded };
};
